import React from "react";

import "./section_3.css";
import tick from "../assets/tick-symbol.png";
// import broucherImg from "../assets/slb-new-1.jpg";

const section3 = () => {
  return (
    <section className="sec-3 show-animate">
      <div className="feature-list">
        <h1 className="features-title">Key Features of The Training </h1>
        <div className="sec-3-center-line"></div>
        <ul className="animate">
          <li style={{ "--i": 0 }}>
            <span>
              <img
                className="tick-sym"
                src={tick}
                alt="tick symbol"
                width={20}
                height={20}
              />
            </span>
            This training is available in 25 hrs pre-recorded video mode in
            English language.{" "}
          </li>
          <li className="animate" style={{ "--i": 1 }}>
            <span>
              <img
                className="tick-sym"
                src={tick}
                alt="tick symbol"
                width={20}
                height={20}
              />
            </span>
            Life time doubts and clarifications support through WA, or SKYPE, or
            ZOOM.
          </li>
          <li className="animate" style={{ "--i": 2 }}>
            <span>
              <img
                className="tick-sym"
                src={tick}
                alt="tick symbol"
                width={20}
                height={20}
              />
            </span>
            25 yrs experienced teaching in practical way.
          </li>
          <li className="animate" style={{ "--i": 3 }}>
            <span>
              <img
                className="tick-sym"
                src={tick}
                alt="tick symbol"
                width={20}
                height={20}
              />
            </span>
            Structural design concepts covered from basic scratch to advanced
            level.
          </li>
          <li className="animate" style={{ "--i": 4 }}>
            <span>
              <img
                className="tick-sym"
                src={tick}
                alt="tick symbol"
                width={20}
                height={20}
              />
            </span>
            Get hands on Experience with industry experts.{" "}
          </li>
          <li className="animate" style={{ "--i": 5 }}>
            <span>
              <img
                className="tick-sym"
                src={tick}
                alt="tick symbol"
                width={20}
                height={20}
              />
            </span>
            Live Project work reviews & guidance's.{" "}
          </li>
          <li className="animate" style={{ "--i": 6 }}>
            <span>
              <img
                className="tick-sym"
                src={tick}
                alt="tick symbol"
                width={20}
                height={20}
              />
            </span>
            Downloadable option for xl files, manuals, books, notes. (Your responsibility to download them and keep in your system or drive during access given time).{" "}
          </li>
          <li className="animate" style={{ "--i": 7 }}>
            <span>
              <img
                className="tick-sym"
                src={tick}
                alt="tick symbol"
                width={20}
                height={20}
              />
            </span>
            Life time after training technical guidance support.{" "}
          </li>
          <li className="animate" style={{ "--i": 8 }}>
            <span>
              <img
                className="tick-sym"
                src={tick}
                alt="tick symbol"
                width={20}
                height={20}
              />
            </span>
            Academic project/thesis support guidance's.
          </li>
          <li className="animate" style={{ "--i": 9 }}>
            <span>
              <img
                className="tick-sym"
                src={tick}
                alt="tick symbol"
                width={20}
                height={20}
              />
            </span>
            Paid internship workshops training for students.
          </li>
        </ul>
        <div className="pricing-btn">
          <a
            href="https://rzp.io/l/01xuMSspo"
            target="_blank"
            rel="noreferrer"
            className="offer-button"
          >
            <button>BOOK NOW</button>
          </a>
        </div>
      </div>

      <div className="topics">
        <h1>Topics of PRACTICAL RCC MANUAL DESIGN TRAINING IN XL SHEETS</h1>
        <div className="sec-4-center-line"></div>
        <ul>
          <li>Basics of Structural design</li>
          <li>Structural design concepts</li>
          <li>Manual loading calculation in xl</li>
          <li>One way slab</li>
          <li>Two way Slab</li>
          <li>Slab Crack check</li>
          <li>Singly Reinforced Beam</li>
          <li>Doubly Reinforced Beam</li>
          <li>Over/Under Reinforced Beams</li>
          <li>Axial columns</li>
          <li>Uniaxial columns</li>
          <li>Biaxial columns</li>
          <li>Double biaxial columns</li>
          <li>Square columns</li>
          <li>Rectangle columns</li>
          <li>Circular columns</li>
          <li>Beam & Column crack checks</li>
          <li>Isolated foundations</li>
          <li>Combined foundations</li>
          <li>Mat foundations</li>
          <li>Raft foundations</li>
          <li>Strip foundations</li>
          <li>Strap foundations</li>
          <li>Pile & Various Pile-Cap Designs</li>
              <li>300+ XL’s of International Codes Included</li>
        </ul>
      </div>

      <a
        href="https://rzp.io/l/01xuMSspo"
        target="_blank"
        rel="noreferrer"
        className="offer-button"
      >
        <button>BOOK NOW</button>
      </a>

      {/* <div className="more-content-div animate">
        <div className="brochureImg-div">
          <a
            href="https://rzp.io/l/01xuMSspo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={broucherImg} alt="broucherImg" className="brochure-img" />
          </a>
        </div>
      </div> */}
    </section>
  );
};

export default section3;
